const GameListReducers = (state = {}, action) => {
  switch (action.type) {
    case "storeGameList":
      return action.payload;
    default:
      return state;
  }
};
export default GameListReducers;
